export const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
export const PNF = require('google-libphonenumber').PhoneNumberFormat;

export function getPhoneHyperlink(phone_number) {
  return <a href={`tel:${phone_number}`}>{phoneUtil.format(phoneUtil.parse(phone_number), PNF.NATIONAL)}</a>;
}
